import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FacebookLogin from 'react-facebook-login';
import moment from 'moment-timezone';
import { facebookLogin } from '../../../actions/AuthActions';

class FacebookLoginButton extends Component {

  constructor(props) {
    super(props);
    this.fbCallback = this.fbCallback.bind(this);
  }

  getAppId() {
    const hostname = window.location.hostname && window.location.hostname.toLowerCase();
    switch (hostname) {
      case 'localhost': return '203261903194460';
      case 'qa.zola.com': return '1440191932862526';
      default: return '215495315286955';
    }
  }

  fbCallback(fbLoginResponse) {
    const { onLoginSuccess, callback, errorCallback } = this.props;
    const requestData = {
      facebook_id: fbLoginResponse.userID,
      short_term_access_token: fbLoginResponse.accessToken,
      timezone: moment.tz.guess()
    };

    onLoginSuccess(requestData)
      .then(callback)
      .catch(errorCallback);
  }

  render() {
    const { buttonText } = this.props;
    return (
      <FacebookLogin
        appId={this.getAppId()}
        autoLoad={false}
        scope="public_profile,email,user_friends"
        textButton={buttonText}
        cssClass="btn btn-facebook btn-block btn-lg"
        icon={(<i className="zolaicon zolaicon-facebook-square hidden-xs" />)}
        isMobile={false}
        callback={this.fbCallback}
      />
    );
  }
}

FacebookLoginButton.propTypes = {
  buttonText: PropTypes.string,
  callback: PropTypes.func,
  errorCallback: PropTypes.func,
  onLoginSuccess: PropTypes.func.isRequired
};

FacebookLoginButton.defaultProps = {
  buttonText: 'Sign Up With Facebook'
};

const mapDispatchToProps = dispatch => (
  {
    onLoginSuccess: fbLoginRequest => dispatch(facebookLogin(fbLoginRequest))
  }
);

export default connect(
  null,
  mapDispatchToProps
)(FacebookLoginButton);



/** WEBPACK FOOTER **
 ** ./src/components/common/auth/FacebookLoginButton.jsx
 **/